// Spread last into NOTIFICATION_HELP_CONTENT: the Staff Messaging Phase 1 notification added by migration 299.
export const NOTE_MENTION_NOTIFICATION_HELP = {
    'staff.note_mention': {
        definition: 'Tells you a colleague @mentioned you in a conversation\'s internal note, with the first words of the note and a link that opens the conversation at that note.',
        who: 'Only the staff named in the note, and only if they can already see that conversation. Drivers and clients never get it.',
        when: 'When the note is saved, once per person per note. The bell always gets it; phone push is on unless you turn it off here, and your quiet hours pause it.',
        source: 'database/migrations/299_staff_note_mentions.sql: note_mentions_after_save',
    },
};
